import { render, staticRenderFns } from "./todo-add-dialog.vue?vue&type=template&id=ddea641e&scoped=true"
import script from "./todo-add-dialog.vue?vue&type=script&lang=js"
export * from "./todo-add-dialog.vue?vue&type=script&lang=js"
import style0 from "./todo-add-dialog.vue?vue&type=style&index=0&id=ddea641e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddea641e",
  null
  
)

export default component.exports